module.exports = __webpack_public_path__ + "img/DSC_0738.NEF.c73f9b00.jpg";